<template>
    <div class="proCard">
        <van-panel :title="pro.orderCode? '订单编号：'+pro.orderCode: ''">
            <div class="proCard-content">
                <div class="card">
                    <div class="proimg">
                        <img :src="pro.productImg" alt="">
                    </div>
                    <div class="info">
                        <div class="title">
                            <div class="text">{{pro.productName}}</div>
                            <div class="price">{{pro.productPrice}}</div>
                        </div>
                        <div class="desc">
                            <div class="text">{{pro.specificationValue}}</div>
                            <div class="num">X{{pro.quantity}}</div>
                        </div>
                        <div class="sign">
                            <van-tag round color="rgba(238,46,80,0.20)" class="pinkTag">{{pro.productBusinessTypeStr}}</van-tag>
                            <!-- <div class="pinkTag">标签</div> -->
                            <van-tag round :color="tagColor">{{pro.accountLvDesc}}</van-tag>
                        </div>
                    </div>
                </div>
                <div class="pro-sum">
                    <div class="time">{{pro.createTime}}</div>
                    <div class="sum-price">
                        共{{pro.quantity}}件商品 合计：¥{{pro.productPaymentAmount}}
                    </div>
                </div>
            </div>
            <div slot="header" class='headerBox'>
                <div>
                    {{pro.orderCode? '订单编号：'+pro.orderCode: ''}}
                </div>
                <!-- <div v-if='pro.proceedsLv2 || pro.proceedsLv1'>
                    赚{{pro.proceedsLv2 ? pro.proceedsLv2 : pro.proceedsLv1}}元
                </div> -->
                <div v-if='pro.proceedsLv2 || pro.proceedsLv1'>
                    赚{{pro.accountLvDesc === '一级账户' ? pro.proceedsLv1 : pro.proceedsLv2}}元
                </div>
            </div>
            <div slot="footer">
                <div></div>
                <div class="from">
                    <p>订单来源：</p>
                    <div class="img">
                        <img :src="pro.accountAvatar" alt="">
                    </div>
                    <p>{{pro.accountName}}</p>
                </div>

            </div>
        </van-panel>

    </div>
</template>

<script>
export default {
    props: ['pro'],
    data() {
        return {
            imageURL: require('@/assets/img/fenxiao/proimg.png')
        };
    },
    computed: {
        tagColor() {
            return this.pro.accountLvDesc === '一级账户' ? '#ff976a' : '#1989fa';
        }
    }
};
</script>

<style lang="scss">
.headerBox{
    overflow: hidden;
    padding:12px;
    border: 1px solid #E3E2E2;
    margin-bottom: 12px;
    div:nth-child(1){
        float: left;
    }
    div:nth-child(2){
        float: right;
        background-color: #FFCDD6;
        border-radius: 4px;
        font-size: 10px;
        color: #EE2E50;
        padding: 2px 7px;
    }
}
.proCard {
    // .van-cell__value {
    //     span {
    //         background-color: #FFCDD6;
    //         border-radius: 4px;
    //         font-size: 10px;
    //         color: #EE2E50;
    //         padding: 2px 7px;
    //     }

    // }
    .van-cell__title {
        font-size: 12px;
        color: #414141;
        .van-cell__label {
            display: none;
        }
    }
    .van-cell .van-cell__title {
        max-width: 220px !important;
    }
    .pro-tag {
        background-color: rgba(238,46,80,0.20);
        text-align: left;
    }
    .proCard-content {
        // padding-top: 11px;
    }
    .card {
        padding: 12px;
        background-color: #f2f2f2;
        display: flex;
        justify-content: space-between;
        .proimg {
            // width: 80px;
            // height: 80px;
            margin-right: 10px;
            img {
                float: left;
                width: 80px;
                height: 80px;
            }
        }
        .info {
            width: calc(100% - 100px);
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            >div {
                display: flex;
                justify-content: space-between;
            }
            .price {
                font-size: 14px;
                color: #414141;
                flex: 1;
                text-align: right;
            }
            .desc {
                font-size: 12px;
                color: #999999;
                .num {
                    flex: 1;
                    text-align: right;
                }
            }
            .sign {
                justify-content: flex-start;
                .pinkTag {
                    margin-right: 10px;
                    &.van-tag {
                        color: #EE2E50;
                    }
                }
            }
            .text {
                flex: 4;
                text-overflow: -o-ellipsis-lastline;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                line-clamp: 2;
                -webkit-box-orient: vertical;
            }
        }

    }
    .pro-sum {
        display: flex;
        justify-content: space-between;
        padding: 12px;
    }
    .van-panel__footer {
        >div{
            display: flex;
            justify-content: space-between;
        }

        .from {
            display: flex;
            line-height: 30px;
        }

        .img {
            width: 30px;
            height: 30px;
            border-radius: 50%;
            overflow: hidden;
            margin-right: 5px;
            img {
                width: 100%;
                height: 100%;
            }
        }
    }
    // .van-card__footer {
    //     right: auto;
    // }
    // .van-card__right div:nth-child(1) {
    //     font-size: 14px;
    //     color: #414141;
    // }

}

</style>
